export default `
    <a 
         id="#= data.id || "" #"
        # if (data.disabled) { # disabled # } #
         class="link bind-label #= data.classes # #=data.bsc||""#"
        # if (data.toolTip) { #
             title="#= data.toolTip #" 
        # } #
        # if (data.href) { #
             href="#= data.href #" 
        # } #
    >
        <span class="bind-label" data-bind="text: #= data.bindLabel #" data-label-for-id="#= data.id #"/>
        <span class="bind-value text-badge badge #= data.countClasses #" data-bind="countText: #= data.bindValue #"/> 
    </a>
`;
